// extracted by mini-css-extract-plugin
export var activityContainer = "_j2-0";
export var typingIndicatorContainer = "_j2-1";
export var typingIndicatorDot = "_j2-2";
export var wave = "_j2-3";